export default 'TOGGLE_DARK_MODE';
